import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useParams } from 'react-router-dom';
import generateDatasetAccessToken from 'api/Dataset/generateDatasetAccessToken';
import { Credential } from 'types/Credentials';
import formatCredentials from 'components/modal/CredentialsModal/FormatCredentials';

enum FormatType {
    Script,
    String,
    Object,
}

export default function useDatasetCredentials(isUserAdmin: boolean) {
    const client = useClient() as unknown as {
        mutate: (mutate: any) => Promise<any>;
    };
    const params = useParams<{ uri: string }>();
    const [credentialLoading, setLoading] = useState(true);
    const [credentials, setCredentials] = useState<Credential[]>([
        { key: '', value: '' },
    ]);
    const [copyCredentials, setCopyCredentials] = useState<string[]>([]);

    const [credentialError, setError] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                if (params.uri) {
                    const response = await client?.mutate(
                        generateDatasetAccessToken(params.uri),
                    );
                    if (!response.errors) {
                        const inputString =
                            response.data.generateDatasetAccessToken;
                        const formattedScript = formatCredentials(
                            inputString,
                            FormatType.Script,
                        );
                        const formattedString = formatCredentials(
                            inputString,
                            FormatType.String,
                        );
                        setCopyCredentials([
                            formattedScript as string,
                            formattedString as string,
                        ]);
                        const formattedObject = formatCredentials(
                            inputString,
                            FormatType.Object,
                        );
                        setCredentials(formattedObject as Credential[]);
                    } else {
                        setError('Could not retrieve dataset credentials');
                    }
                }
            } finally {
                setLoading(false);
            }
        };

        if (client && isUserAdmin) {
            fetchData();
        }
    }, [client, params.uri, isUserAdmin]);

    return { credentials, credentialError, credentialLoading, copyCredentials };
}
